<template>
    <div class="production-control-wrapper">
        <div v-if="isLoading" class="loading">
            <SpeenComponent
                :isAutomatic="true"
                :ringWidth="14"
                :spinnerSize="15"
                :isverticalAligned="true"
            ></SpeenComponent>
        </div>
        <div v-else>
            <ControlProduccionHeader/>
            <Kanban />
            <MultiModal/>
        </div>
    </div>
</template>

<script>
import Kanban from "../components/Kanban.vue";
import Modal from "../components/Modal";
import {mapActions, mapGetters} from "vuex";
import MultiModal from "../components/MultiModal";
import axios from "axios";
import ControlProduccionHeader from "../components/ControlProduccionHeader";
import SpeenComponent from "../../common/components/SpeenComponent";
import {FilterTypes} from "../components/FilterTypes";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import EchoEvents from "../../common/echo/echo_events";
import EchoChannels from "../../common/echo/echo_channels";

export default {
    name: "ControlProduccion",
    data(){
        return {
            isLoading: true,
            retrievingCompleteData: false,
            retrievingPartialData: false,
            lastTimelineOrderReference: {
                production_line_id: null,
                start_date: null,
                end_date: null
            },
            timelineOrderReferenceMoved: false,
            storeKanbanDataInterval: null,
            loadingCompleteDataByWebsocket: false,
        }
    },
    components:{
        SpeenComponent,
        ControlProduccionHeader,
        MultiModal,
        Modal,
        Kanban
    },
    methods:{
        ...mapActions(['createProductionLine', 'initializeProductionLines']),
        ...mapActions('production_control', ['createKanban','createKanbanPendingList','createCalendarEvent','updateCalendarEvent','deleteCalendarEvent','deleteAllCalendarEvents','updateFilter','setLastUpdateTime','deleteOrderReferenceCalendarEvents','addCalendarEvents', 'setShowKanbanContainerOverlay']),
        storeCompleteKanbanData () {
            return new Promise((resolve, reject) => {
                var self = this;
                if(this.retrievingCompleteData || this.queueEditActive) return;
                this.retrievingCompleteData = true;
                axios
                .get(`/api/production-control/get-complete-kanban`)
                .then( res => {
                    if(res.hasOwnProperty('data') && !self.queueEditActive){
                        self.createKanban(res.data?.productionLines);
                        self.createKanbanPendingList(res.data?.orderReferencesPending);
                        self.createCalendarEvents(res.data?.orderReferenceEvents, res.data?.shiftEvents, res.data?.scheduledStopsEvents);
                        self.setUpdateTime();
                        if(self.loadingCompleteDataByWebsocket){
                            self.loadingCompleteDataByWebsocket = false;
                            showCustomSuccessSweetAlert('La información ha sido actualizada');
                        }
                        self.disableShowKanbanContainerOverlay();
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch( err => {
                    console.log(err)
                    showCustomErrorSweetAlert(err.response.data);
                    reject(err)
                })
                .finally(() => {
                    self.retrievingCompleteData = false;
                    
                })
            })
        },
        storePartialKanbanData () {
            var self = this;
            axios
            .get(`/api/production-control/get-partial-kanban`)
            .then( res => {
                if(res.hasOwnProperty('data') && !self.queueEditActive){
                    self.createKanban(res.data?.productionLines);
                    self.createKanbanPendingList(res.data?.orderReferencesPending);
                    self.refreshOrderReferenceEvents(res.data?.orderReferenceEvents);
                    self.setUpdateTime();
                    // self.disableShowKanbanContainerOverlay();
                }
            })
            .catch( err => {
                console.log(err)
                showCustomErrorSweetAlert(err.response.data);
            })
            .finally(() => {
                self.retrievingPartialData = false;
            })
        },
        createCalendarEvents(orderReferenceEvents, shiftEvents, scheduledStopsEvents){
            var self = this;
            var events = [];
            if (orderReferenceEvents) events.push(...orderReferenceEvents.flat().filter(i => i));
            if (shiftEvents) events.push(...shiftEvents.flat().filter(i => i));
            if (scheduledStopsEvents) events.push(...scheduledStopsEvents.flat().filter(i => i));

            new Promise((resolve, reject) => {
                try {
                    self.deleteAllCalendarEvents();
                    resolve(events);
                } catch (error) {
                    reject(error);
                }
            }).then((events) => {
                if(events.length === 0) return;
                events.flat().forEach(event => self.createCalendarEvent(event));
            }).catch((error) => {
                console.error('Error al procesar eventos:', error);
            });
        },
        refreshOrderReferenceEvents(orderReferenceEvents){
            var self = this;
            new Promise((resolve, reject) => {
                try {
                    self.deleteOrderReferenceCalendarEvents();
                    resolve(orderReferenceEvents);
                } catch (error) {
                    reject(error);
                }
            }).then((events) => {
                if(events.length === 0) return;
                self.addCalendarEvents(events.flat().filter(i => i));
            }).catch((error) => {
                console.error('Error al procesar eventos:', error);
            });
        },
        setUpdateTime(){
            var today = new Date();
            let h = String(today.getHours()),
                m = String(today.getMinutes()),
                s = String(today.getSeconds());

            var time = (h.length === 1?`0${h}`:h) + ":" + (m.length === 1?`0${m}`:m) + ":" + (s.length === 1?`0${s}`:s);
            this.setLastUpdateTime(time)
        },
        startStoreKanbanDataInterval(){
            let self = this;
            this.storeKanbanDataInterval = setInterval(
                function()
                {
                    if(self.retrievingCompleteData || self.retrievingPartialData || self.queueEditActive) return;
                    self.retrievingPartialData = true;
                    self.storePartialKanbanData()
                }
            , 10000)
        },
        stopStoreKanbanDataInterval(){
            clearInterval(this.storeKanbanDataInterval)
        },
        restartStoreKanbanDataInterval(){
            this.stopStoreKanbanDataInterval();
            this.startStoreKanbanDataInterval();
        },
        mountedActions(){
            this.initializeFilters();
            this.prepareEchoEvents();
            this.initializePLAndStartKanbanDataInterval();
        },
        prepareEchoEvents(){
            window.Echo.private(EchoChannels.PRIVATE.GLOBAL_PRODUCTION)
                .listen(EchoEvents.QUEUE_RECALCULATION_EVENT, () => {
                    this.handleQueueRecalculationEvent();
                })
            window.Echo.private(EchoChannels.PRIVATE.GLOBAL_PRODUCTION)
                .listen(EchoEvents.ORDER_REFERENCE_STATE_CHANGED_EVENT, () => {
                    this.handleOrderReferenceStateChangedEvent();
                })
        },
        initializeFilters(){
            Object.values(FilterTypes).forEach(filter => {
                this.updateFilter({name:filter, value:null})
            })
        },
        initializePLAndStartKanbanDataInterval(){
            let self = this;
            $.when(this.initializeProductionLines(), this.storeCompleteKanbanData())
            .then(() => {
                self.isLoading = false;
                this.startStoreKanbanDataInterval();
            })
        },
        handleQueueRecalculationEvent() {
            if(this.queueEditActive) return;
            this.storeCompleteKanbanData();
            this.restartStoreKanbanDataInterval();
            this.loadingCompleteDataByWebsocket = true;
        },
        handleOrderReferenceStateChangedEvent() {
            if(this.queueEditActive) {
                return Swal.fire({
                    title: '¡Atención!',
                    html: 'Se ha detectado un cambio en la cola de producción mientras estaba editando.<br>Por favor, recargue la página para ver los cambios.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#27884F',
                    cancelButtonColor: 'red',
                    confirmButtonText: 'Recargar',
                    cancelButtonText: 'Cancelar',
                    footer: '<small>Pueden haber fallos si continúa sin los últimos cambios</small>'
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            }
        },
        disableShowKanbanContainerOverlay(){
            this.setShowKanbanContainerOverlay(false);
        },
    },
    computed:{
        ...mapGetters('production_control', ['kanban', 'kanbanOrderReferences','kanbanOrderReferencesByStateId',
                'kanbanOrderReferencesInQueueByProductionLineId','kanbanOrderReferencesByStateIdAndProductionLineId', 'calendarEvents', 'queueEditActive']),
    },
    mounted(){
        this.mountedActions();
    },
}
</script>
